import axios from "axios";
import VueAxios from "vue-axios";

const init = (vue) => {
  axios.defaults.baseURL = window.env.LOONITY_BASE_API_URL;
  vue.use(VueAxios, axios);
};

export default init;
